import { Component, ElementRef, ViewChild } from '@angular/core';
declare var bootstrap: any;

@Component({
  selector: 'app-interest-shared-success-popup',
  imports: [],
  templateUrl: './interest-shared-success-popup.component.html',
  styleUrl: './interest-shared-success-popup.component.scss'
})
export class InterestSharedSuccessPopupComponent {

  /** ViewChild reference to the modal HTML element */
  @ViewChild('successModal') successModal!: ElementRef;
  private modalInstance: any; // keep a single reference
  gifSrc = '';
  buttonColor: string = '#008940';
  forValue: string = '';

  /**
     * Displays the Bootstrap modal by initializing and showing it.
     */
  show(color?: string, forValue?: string): void {
    if (color) {
      this.buttonColor = color;
    }
    if (forValue) {
      this.forValue = forValue;
    }
    if (!this.modalInstance) {
      this.modalInstance = new bootstrap.Modal(this.successModal.nativeElement);
    }
    this.reloadGif();
    this.modalInstance.show();
  }

  hide(): void {
    if (this.modalInstance) {
      this.modalInstance.hide(); // correctly hides the same instance
    }
  }

  private reloadGif(): void {
    this.gifSrc = `assets/images/check.gif?ts=${Date.now()}`;
  }

}
